var React = require('react');

function Arrow2Down (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23.831 10.623c-.207-.184-.524-.163-.705.045l-10.125 11.505v-21.675c0-.276-.224-.5-.5-.5s-.5.224-.5.5v21.675l-10.125-11.505c-.183-.208-.499-.229-.705-.045-.208.182-.227.498-.045.705l11 12.5.011.008.123.091.04.027.201.043.201-.043.04-.027.123-.091.011-.008 11-12.5c.183-.207.163-.523-.045-.705z"}));
}

Arrow2Down.defaultProps = {"version":"1","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Arrow2Down;

Arrow2Down.default = Arrow2Down;
